import { render, staticRenderFns } from "./ChatChatCustomerExpansion.vue?vue&type=template&id=32d1eaa2&"
import script from "./ChatChatCustomerExpansion.vue?vue&type=script&lang=js&"
export * from "./ChatChatCustomerExpansion.vue?vue&type=script&lang=js&"
import style0 from "./ChatChatCustomerExpansion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports